import Vue from 'vue'
import { getTokenRedirect, isLoggedIn } from "@/services/auth/redirectLogin";
import VueRouter from 'vue-router'
import Index from '@/views/modules/general/pages/Index.vue'
import Admin from '@/views/modules/admin_panel/pages/Users.vue'
import BulletinBoard from '@/views/modules/admin_panel/pages/BulletinBoard.vue'

import UserEdit from '@/views/modules/admin_panel/pages/UserEdit.vue'

import permissioner from '../services/permissioner'

import { case_routes } from "./case/handler.js"
import { project_routes } from "./project/handler.js"


import Login from '@/views/modules/general/pages/Login.vue'

import NoPermission from '@/views/modules/general/pages/NoPermission.vue'

import CRM from '@/views/modules/crm/pages/CRM.vue'
import CRMNewEdit from '@/views/modules/crm/forms/EnterNewPerson.vue'
import CRMprofil from '@/views/modules/crm/pages/CRMprofil.vue'
import PersonProfile from '@/views/modules/persons_management/pages/PersonProfile.vue'
import Persons from '@/views/modules/persons_management/pages/Persons.vue'
import Institutions from '@/views/modules/persons_management/pages/Institutions.vue'
import PotentialClients from '@/views/modules/crm/pages/PotentialClients.vue'
import Tarife from '@/views/modules/billing_management/pages/Tarife.vue'
import Sifarnik from '@/views/modules/billing_management/pages/Sifarnik.vue'
import TemplateDocs from '@/views/modules/general/pages/TemplateDocs.vue'
import IndexKnowledgeManagement from '@/views/modules/knowledge_management/pages/Index.vue'
import GeneralNaplata from '@/views/modules/billing_management/pages/GeneralNaplata.vue'
import GeneralFakture from '@/views/modules/billing_management/pages/GeneralFakture.vue'
import Banking from '@/views/modules/billing_management/pages/Banking.vue'


import FAQ from '@/views/modules/general/pages/FAQ.vue'

import CalendarGeneral from '@/views/modules/general/pages/CalendarGeneral.vue'
import ComingSoon from '@/views/modules/general/pages/ComingSoon.vue'

import Analytics from '@/views/modules/analytics/pages/Analytics.vue'
import Office from '@/views/modules/office_management/pages/Office.vue'
import Assets from '@/views/modules/office_management/pages/Assets.vue'
import AssetsServices from '@/views/modules/office_management/pages/AssetsServices.vue'




import EnterNewPerson from '@/views/modules/persons_management/forms/EnterNewPerson.vue'
import EnterNewPersonalEvent from '@/views/modules/general/forms/EnterNewPersonalEvent.vue'
import RocistaReport from '@/views/modules/reports/RocistaReport.vue'
import PredmetiReport from '@/views/modules/reports/PredmetiReport.vue'

import OsobeListReport from '@/views/modules/reports/OsobeListReport.vue'

import TroskovnikReport from '@/views/modules/reports/TroskovnikReport.vue'
import NaplataReport from '@/views/modules/reports/NaplataReport.vue'
import TempReport from '@/views/modules/reports/TempReport.vue'
import BreakdownReport from '@/views/modules/reports/BreakdownReport.vue'
import CaseStateReport from '@/views/modules/reports/CaseStateReport.vue'
import RacunovodstvoNalozi from '@/views/modules/billing_management/pages/RacunovodstvoNalozi.vue'
import GeneralCashFlow from '@/views/modules/billing_management/pages/GeneralCashFlow.vue'




// PROJECT ROUTES END
import auth from '@/services/auth'

Vue.use(VueRouter)

var routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/bulletin-board',
    name: 'BulletinBoard',
    component: BulletinBoard,
    meta: { requiresAuth: true }
  },
  {
    path: '/no-persmission',
    name: 'NoPermission',
    component: NoPermission,
    meta: { requiresAuth: true }
  },
  {
    path: '/personal-profile',
    name: 'UserEdit',
    component: UserEdit,
    meta: { requiresAuth: true }
  },

  {
    path: '/u-pripremi',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: { requiresAuth: true }
  },

  // All casses routes END
  {
    path: '/crm/',
    name: 'CRM',
    component: CRM,
    meta: { requiresAuth: true }
  },
  {
    path: '/crm/new',
    name: 'CRMNewPerson',
    component: CRMNewEdit,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/crm/profile',
    name: 'CRMprofil',
    component: CRMprofil,
    meta: { requiresAuth: true }
  },
  {
    path: '/osobe/fiz/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/fiz/:oib/edit',
    name: 'PhisicalPersonEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/institucije/:oib/edit',
    name: 'InstitutionEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }

  },
  {
    path: '/osobe/law/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/prav/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/prav/:oib/edit',
    name: 'LegalPersonEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/institucije/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg-body/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg-body/:oib/edit',
    name: 'LegalBodyEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true }
  },
  {
    path: '/osobe/',
    name: 'Persons',
    component: Persons,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/institucije/',
    name: 'institucije',
    component: Institutions,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/tarife/',
    name: 'Tarife',
    component: Tarife,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.billing.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/sifarnik/',
    name: 'sifarnik',
    component: Sifarnik,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.statuses.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/template-docx/',
    name: 'templates-documents',
    component: TemplateDocs,
    meta: { requiresAuth: true },
  },
  {
    path: '/knowledge-management/',
    name: 'KnowledgeManagment',
    component: IndexKnowledgeManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/naplata/',
    name: 'naplata',
    component: GeneralNaplata,
    meta: { requiresAuth: true }
  },
  {
    path: '/izdane-fakture/',
    name: 'fakture',
    component: GeneralFakture,
    meta: { requiresAuth: true }
  },
  {
    path: '/banking/',
    name: 'banking',
    component: Banking,
    meta: { requiresAuth: true }
  },
  {
    path: '/faq/',
    name: 'faq',
    component: FAQ,
    meta: { requiresAuth: true }
  },
  {
    path: '/potencijalni/',
    name: 'PotentialClients',
    component: PotentialClients,
    meta: { requiresAuth: true }
  },


  {
    path: '/nova-osoba/',
    name: 'EnterNewPerson',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) {
        next()
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },


  { //trebamo imati jedan page i za skupni kalendar - privremeno
    path: '/kalendar',
    name: 'CalendarGeneral',
    component: CalendarGeneral,
    meta: { requiresAuth: true }
  },
  {
    path: '/kalendar/novi-osobni-dogadaj',
    name: 'EnterNewPersonalEvent',
    component: EnterNewPersonalEvent,
    meta: { requiresAuth: true }
  },
  {
    path: '/rocista-report',
    name: 'RocistaReport',
    component: RocistaReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/breakdown-report',
    name: 'BreakdownReport',
    component: BreakdownReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/predmeti-report',
    name: 'PredmetiReport',
    component: PredmetiReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/people-list-report',
    name: 'OsobeListReport',
    component: OsobeListReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/troskovnik-report',
    name: 'TroskovnikReport',
    component: TroskovnikReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/naplata-report',
    name: 'NaplataReport',
    component: NaplataReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/temp-report',
    name: 'TempReport',
    component: TempReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/cases-state-report',
    name: 'CaseStateReport',
    component: CaseStateReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/analitika',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/ured',
    name: 'Office',
    component: Office,
    meta: { requiresAuth: true }
  },
  {
    path: '/assets',
    name: 'Assets',
    component: Assets,
    meta: { requiresAuth: true }
  },
  {
    path: '/assets-services',
    name: 'AssetsServices',
    component: AssetsServices,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/racunovodstvo-nalozi/',
    name: 'RacunovodstvoNalozi',
    component: RacunovodstvoNalozi,
    meta: { requiresAuth: true }
  },
  {
    path: '/cash-flow/',
    name: 'GeneralCashFlow',
    component: GeneralCashFlow,
    meta: { requiresAuth: true }
  },

]
function isIphone() {
  const toMatch = [
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return window.navigator.userAgent.match(toMatchItem);
  });
}

routes = routes.concat(case_routes)
routes = routes.concat(project_routes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  var currentUser = null;
  let login_status = isLoggedIn();
  // if (isLoggedIn()) {
  //   auth.configure(process.env.VUE_APP_CLIENT_ID)

  //   // Restore any cached or saved local user

  // }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  //workaround da nakon logina na iphoneu radi inicijalni load stranice
  // if (to.fullPath.startsWith('/login#id_token') && isIphone()) {
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, 2500);
  // }
  if (login_status) {
    await permissioner.getLoggedInUser();
  }


  if (requiresAuth && !login_status) next("login");
  else if (!requiresAuth && login_status) next("/");
  else next();
  // next()
});

export default router;
